// extracted by mini-css-extract-plugin
export default {"content":"styles_content__aAYgI","alert":"styles_alert__Gh9p3"};